<div class="bg-th-yellow mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center h-35">
        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>
        <span class="my-auto f16 fw-bold me-2"> سوخت براساس گزارش ثبت‌شده</span>
    </div>
</div>

<main style="direction: rtl;" class="py-4 px-2">
    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">
        <!-- از تاریخ -->
        <div class="col-12 col-md-2 position-relative">
            <label> از تاریخ </label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
            </ng-persian-datepicker>
        </div>
        <!-- تا تاریخ -->
        <div class="col-12 col-md-2 position-relative">
            <label> تا تاریخ </label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
            </ng-persian-datepicker>
        </div>
        <!-- جستجو -->
        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">
            <button class="btn btn-primary w-100" (click)="getResult()">
                جستجو
            </button>
        </div>
        <!-- خروجی اکسل -->
        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">
            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')">
                خروجی اکسل
            </button>
        </div>
    </form>
    <div class="border border-2 mt-3 p-2">
        <div class="row gx-0 gy-2 gy-md-0">
            <div class="col-12">
                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm
                    (keyup)="filterResult($event.target)">
            </div>
        </div>
        <div class="section border border-2 mt-2" style="height:calc(100dvh - 235px);overflow: auto;">
            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
                <thead>
                    <tr class="">
                        <th class="text-center col-1"> # </th>
                        <th class="text-center col-1"> عملیات </th>
                        <th class="text-center col-1"> نام </th>
                        <th class="text-center col-1"> پلاک </th>
                        <th class="text-center col-1"> نوع </th>
                        <th class="text-center col-1"> تعداد سوخت‌گیری </th>
                        <th class="text-center col-1"> جمع(لیتر)</th>
                        <th class="text-center col-1"> هزینه(ریال)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="col-12 text-center" *ngFor="let item of lst_Result;let i = index">
                        <th> {{ i + 1 | faNum }} </th>
                        <td class="">
                            <i class="fa fa-info-circle fs-5 pointer" title="جزئیات" (click)="openDetails(item)"></i>
                        </td>
                        <td> {{ item.strFullName }} </td>
                        <td> {{ item.strVehicleNo | faNum }} </td>
                        <td> {{ item.strMobileType_strComment }} </td>
                        <td> {{ item.iCount | faNum }} </td>
                        <td> {{ item.fLiter.toLocaleString('fa-IR') }} </td>
                        <td> {{ item.iCost.toLocaleString('fa-IR') }} </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="col-12 text-center table-total-row bg-light-2">
                        <th colspan="1"> مجموع </th>
                        <td colspan="5"></td>
                        <th>{{totalLiter.toLocaleString('fa-IR')}}</th>
                        <th>{{totalCost.toLocaleString('fa-IR')}}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <div class="modal fade" id="detailsModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content dirI">
                <div class="modal-header dirI">
                    <h5 class="modal-title" id="exampleModalLabel"> جزئیات سوخت‌گیری </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="section border border-2 mt-2" style="max-height:60vh;overflow: auto;">
                        <table class="col-12 table table-striped rounded-3" id="Export_Excel_2">
                            <thead>
                                <tr class="">
                                    <th class="text-center col-1"> # </th>
                                    <th class="text-center col-1"> کاربر ثبت‌کننده </th>
                                    <th class="text-center col-1"> تاریخ </th>
                                    <th class="text-center col-1"> مبلغ (ریال) </th>
                                    <th class="text-center col-1"> لیتر </th>
                                    <th class="text-center col-1"> کیلومتر</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="col-12 text-center" *ngFor="let item of fuelDetails;let i = index">
                                    <th> {{ i + 1 | faNum }} </th>
                                    <td> {{ item.strUserSaved }} </td>
                                    <td> {{ item.strDate | faNum }} </td>
                                    <td> {{ item.iCost.toLocaleString('fa-IR') }} </td>
                                    <td> {{ item.fLiter.toLocaleString('fa-IR') }} </td>
                                    <td> {{ item.iKm.toLocaleString('fa-IR') }} </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer d-flex justify-content-start">
                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
                        &nbsp; بستن &nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</main>